import axios from 'axios'
// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.VUE_APP_REQUEST_URL || '/admin_xun_dian',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'content-type': 'application/json'
  },
  timeout: 300000,
  method: 'post'
})

axios.defaults.withCredentials = true

service.interceptors.request.use(
  (config) => {
    if (!config.notUseQstring) config.data = qs.parse(qs.stringify(config.data || '{}'))

    // console.log('url :>> ', config.url)
    // console.log('接口参数 :>> ', config, config.data)
    return config
  },
  (error) => Promise.reject(error)
)

service.interceptors.response.use(
  (res) => {
    const { desc, status } = res.data
    if (status !== 200) {
      // 兼容后端有些接口返回 desc 为 null 的情况   Wu
      const msg = desc || '消息为空，忽略即可'
      Message.error(msg)
      return Promise.reject(new Error(msg))

      // new Error(desc)
      // return Promise.reject(error)
    }
    return res.data
  },
  (error) => {
    const errorMessage =
      error.response.status === 500 ? 'uncatch error' : error.response.data.message

    if (error.response.status === 401) {
      Message.error('用户未授权')

      localStorage.login = false
      window.location.reload()
    }

    Message.error(errorMessage)
    return Promise.reject(error)
  }
)

export default service
